import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const TEXTS = {
    en: 'TRANSLATING',
    it: 'TRADUCENDO',
};

const TYPEWRITER_SPEED = 60;
const DOTS_INTERVAL = 400;

const TranslationOverlay = () => {
    const { isTranslating, pendingLanguage } = useLanguage();
    const [displayedText, setDisplayedText] = useState('');
    const [dots, setDots] = useState('');

    useEffect(() => {
        if (!isTranslating) {
            setDisplayedText('');
            setDots('');
            return;
        }

        const fullText = TEXTS[pendingLanguage] ?? 'translating';
        let i = 0;
        setDisplayedText('');

        const typeTimer = setInterval(() => {
            i++;
            setDisplayedText(fullText.slice(0, i));
            if (i >= fullText.length) clearInterval(typeTimer);
        }, TYPEWRITER_SPEED);

        const dotsTimer = setInterval(() => {
            setDots(prev => prev.length >= 3 ? '' : prev + '.');
        }, DOTS_INTERVAL);

        return () => {
            clearInterval(typeTimer);
            clearInterval(dotsTimer);
        };
    }, [isTranslating, pendingLanguage]);

    return (
        <AnimatePresence>
            {isTranslating && (
                <motion.div
                    key="translation-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none"
                    style={{ backgroundColor: 'rgba(0,0,0,0.82)' }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.2, delay: 0.05 }}
                        className="flex items-center gap-1"
                    >
                        <span
                            className="font-mono text-white tracking-widest"
                            style={{ fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', letterSpacing: '0.15em' }}
                        >
                            {displayedText}
                        </span>
                        <span
                            className="font-mono text-white"
                            style={{ fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', minWidth: '1.8ch' }}
                        >
                            {dots}
                        </span>
                        <span
                            className="font-mono text-white animate-pulse ml-0.5"
                            style={{ fontSize: 'clamp(1rem, 2.5vw, 1.5rem)' }}
                        >
                            |
                        </span>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default TranslationOverlay;
